<template>
  <div class="">
    <!--    <h1>Local schedule table container</h1>-->
    <!--    <schedule-table-container container-client-domain="localhost:8080"-->
    <schedule-table-container :container-client-domain="ownerDomain"
                              :is-logged-in="isLoggedIn"
                              :is-mobile-device="isMobileDevice"
                              @changeCurrentTableDate="alert('changeCurrentTableDate')"
                              @create-new-reservation="(payload) => this.$emit('create-new-reservation', payload)"
                              @resign-reservation="(payload) => this.$emit('resign-reservation', payload)"
    />
    <!--    <guest-schedule v-if="tables.length > 0"-->
    <!--                    :tables="tables"-->
    <!--                    :is-logged-in="isLoggedIn"-->
    <!--                    :table-date="currentTableDate"-->
    <!--                    :is-mobile-device="isMobileDevice"-->
    <!--                    @create-new-reservation="createNewReservation"-->
    <!--                    @resign-reservation="resignReservation"-->
    <!--                    @changeCurrentTableDate="changeCurrentTableDate"/>-->
  </div>
</template>

<script>
import ScheduleTableContainer from '@/components/schedule/ScheduleTableContainer';

export default {
  props: ['tables', 'isLoggedIn', 'isMobileDevice'],
  methods: {},
  computed: {
    currentTableDate () {
      return this.$store.state.currentTableDate
    },
    ownerDomain () {
      return this.$store.state.ownerDomain
    },
  },
  mounted () {
    console.log('-------> here is the trick <------------');
    console.log('host: ', window.location.host)
    this.$store.dispatch('selectClient', this.$store.state.ownerDomain);
  },
  components: {
    ScheduleTableContainer,
  },
}
</script>

<style scoped>
</style>
